import {
  fetchAll,
  fetchFiltered,
  add,
  edit,
  show,
} from "@/api/financialservice";

const state = {
  all: [],
  isLoading: false,
  financialServiceById: null,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      const financialServices = await fetchAll();
      commit("setAll", financialServices);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchById({ dispatch, commit }, id) {
    try {
      const financialService = await show(id);
      commit("setFinancialServiceById", financialService);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async fetchFiltered({ dispatch, commit }, queriesParams) {
    try {
      const financialServices = await fetchFiltered(queriesParams);
      commit("setAll", financialServices);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    }
  },

  async edit({ dispatch, commit }, { id, data }) {
    commit("setLoading", true);
    try {
      await edit(id, data);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },

  async create({ dispatch, commit }, status) {
    commit("setLoading", true);
    try {
      await add(status);
      return true;
    } catch (e) {
      dispatch("notify/error", msg, { root: true });
    } finally {
      commit("setLoading", false);
    }
    return false;
  },
};

const mutations = {
  setAll(state, financialService) {
    state.all = financialService;
  },

  setFinancialServiceById(state, financialService) {
    state.financialServiceById = financialService;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
    state.financialServiceById = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
